import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { ItemComponent } from "./components/ItemComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { MixChemicalsComponent } from "./components/MixChemicalsComponent";
import { CharacterComponent } from "./components/CharacterComponent";
import { MorsePuzzleComponent } from "./components/MorseCodeComponent";
import { NumericLockComponent } from "./components/LockComponent";
import { MiniGameComponent } from "./components/Room1MiniGameComponent";
import { MemoryGameComponent } from "./components/MemoryGameComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-item", ItemComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("character-component", CharacterComponent);
window.customElements.define("mini-game", MiniGameComponent);
window.customElements.define("mix-chemicals", MixChemicalsComponent);
window.customElements.define("memory-game", MemoryGameComponent);
window.customElements.define("morse-puzzle", MorsePuzzleComponent);
window.customElements.define("numeric-lock", NumericLockComponent);
